import { Injectable, inject } from '@angular/core';

import { WidgetConfig } from '@frontend/sports/common/client-config-data-access';
import { WidgetPage } from '@frontend/sports/types/components/widget';
import { WidgetRefreshTrigger } from '@frontend/sports/widget/core/feature';

@Injectable({ providedIn: 'root' })
export class EsportsRefreshTrigger extends WidgetRefreshTrigger {
    constructor() {
        const config = inject(WidgetConfig);

        super(config);
    }

    getPage(): WidgetPage {
        return WidgetPage.ESportsLobby;
    }
}
